export default __webpack_public_path__ + "static/media/detail.27ddba36.png";